module.exports = __webpack_public_path__ + "img/diente82.2e741db2.png";